import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { authApi } from 'redux/services/auth/auth.slice';
import app from 'redux/features/app/app.slice';
import filePermissions from 'redux/features/filePermissions/filePermissions.slice';
import incentives from 'redux/features/incentives/incentives.slice';
import recallCompliance from 'redux/features/recallCompliance/recallCompliance.slice';
import productPlanning from 'redux/features/productPlanning/productPlanning.slice';
import imdValidation from 'redux/features/fileValidation/imd.slice';
import vinValidation from 'redux/features/fileValidation/vin.slice';
import priceMatrixValidation from 'redux/features/fileValidation/priceMatrix.slice';
import nomenclatureGuideValidation from 'redux/features/fileValidation/nomenclatureGuide.slice';
import techSpecsValidation from 'redux/features/fileValidation/techSpecs.slice';
import pplValidation from 'redux/features/fileValidation/ppl.slice';
import imdVersionHistory from 'redux/features/fileVersionHistory/imd.slice';
import vinVersionHistory from 'redux/features/fileVersionHistory/vin.slice';
import pplVersionHistory from 'redux/features/fileVersionHistory/ppl.slice';
import nomenclatureGuideVersionHistory from 'redux/features/fileVersionHistory/nomenclatureGuide.slice';
import priceMatrixVersionHistory from 'redux/features/fileVersionHistory/priceMatrix.slice';
import techSpecsVersionHistory from 'redux/features/fileVersionHistory/techSpecs.slice';
import pcdfVersionHistory from 'redux/features/fileVersionHistory/pcdf.slice';
import mvdfVersionHistory from 'redux/features/fileVersionHistory/mvdf.slice';
import priceGuideVersionHistory from 'redux/features/fileVersionHistory/priceGuide.slice';
import taxImportVersionHistory from 'redux/features/fileVersionHistory/taxImport.slice';
import toolboxVersionHistory from 'redux/features/fileVersionHistory/toolbox.slice';
import vehicleTechSpecsVersionHistory from 'redux/features/fileVersionHistory/vehicleTechSpecs.slice';
import pfaVersionHistory from 'redux/features/fileVersionHistory/pfa.slice';
import topFeaturesSpecsVersionHistory from 'redux/features/fileVersionHistory/topFeatures.slice';
import featuresGuideVersionHistory from 'redux/features/fileVersionHistory/featuresGuide.slice';
import { cognitoApi } from './services/cognito/cognito.slice';
import { fileValidationApi } from './services/fileValidation/fileValidation.slice';
import { fileGenerationApi } from './services/fileGeneration/fileGeneration.slice';
import { s3BucketApi } from './services/s3Bucket/s3Bucket.slice';
import { filePermissionsMiddleware } from './middlewares';

const logger = createLogger();

export function setupStore(preloadedState) {
  return configureStore({
    reducer: {
      app,
      filePermissions,
      incentives,
      recallCompliance,
      productPlanning,
      imdValidation,
      vinValidation,
      priceMatrixValidation,
      nomenclatureGuideValidation,
      techSpecsValidation,
      pplValidation,
      imdVersionHistory,
      vinVersionHistory,
      pplVersionHistory,
      nomenclatureGuideVersionHistory,
      priceMatrixVersionHistory,
      techSpecsVersionHistory,
      pcdfVersionHistory,
      mvdfVersionHistory,
      priceGuideVersionHistory,
      taxImportVersionHistory,
      toolboxVersionHistory,
      vehicleTechSpecsVersionHistory,
      pfaVersionHistory,
      topFeaturesSpecsVersionHistory,
      featuresGuideVersionHistory,
      [authApi.reducerPath]: authApi.reducer,
      [cognitoApi.reducerPath]: cognitoApi.reducer,
      [s3BucketApi.reducerPath]: s3BucketApi.reducer,
      [fileValidationApi.reducerPath]: fileValidationApi.reducer,
      [fileGenerationApi.reducerPath]: fileGenerationApi.reducer,
    },
    preloadedState,
    middleware: (getDefaultMiddleware) => {
      const defaultMiddleware = getDefaultMiddleware({
        serializableCheck: false,
      }).concat(
        filePermissionsMiddleware,
        authApi.middleware,
        cognitoApi.middleware,
        s3BucketApi.middleware,
        fileValidationApi.middleware,
        fileGenerationApi.middleware,
      );

      return process.env.NODE_ENV === 'production'
        ? defaultMiddleware
        : defaultMiddleware.concat(logger);
    },
  });
}
